import React from "react";

import Sidebar from "components/sidebar/Sidebar.js";

import {
  Box,
  useColorModeValue,
  Portal,
  useDisclosure,
  SimpleGrid,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import Navbar from "components/navbar/NavbarAdmin.js";
import MiniStatistics from "components/card/MiniStatistics";
import { MdBarChart } from "react-icons/md";
import ModalAllPages from "components/pdf/ModalAllPages";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { SidebarContext } from "contexts/SidebarContext";
// Custom components
import Card from "components/card/Card";
// Custom components

import { fetchList } from "api/function";
import { addFunction } from "api/function";
import Loader from "components/Loader";
import routes from "routes.js";

import ResizableTable from "components/ResizableTable";

import IconBox from "components/icons/IconBox";

import BigQueryModal from "components/bigQueryModal";

import { Flex, Text, Icon, Button } from "@chakra-ui/react";
import {
  getActiveRoute,
  getActiveNavbar,
  getActiveNavbarText,
} from "helper/UploadFilePageHelper";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { useSelector } from "react-redux";
import {
  selectUploadFileModuleData,
  selectUploadFileModuleFiles,
} from "redux/selectorFunctions";
import DummyPDF from "assets/dummy-11.pdf";
import pdf1 from "assets/pdfs/contracts/SARAH WILLIAMS.pdf";
import pdf2 from "assets/pdfs/contracts/SOPHIA HARRIS - PHSP Agreement.pdf";

import { selectSelectedModuleID } from "redux/selectorFunctions";
import { generalizeTableClaimJSON } from "utility/commonFunctions";
const api_url = process.env.REACT_APP_API;

export default function Marketplace(props) {
  const navigate = useNavigate();
  const { onOpen } = useDisclosure();

  const selectUploadFileModuleDataRedux = useSelector(
    selectUploadFileModuleData
  );

  const selectUploadFileModuleFileRedux = useSelector(
    selectUploadFileModuleFiles
  );
  const selectSelectedModulesIDRedux = useSelector(selectSelectedModuleID);

  const [loading, setLoading] = useState(true);
  const [modalLoading, setModalLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [bigQuerySuccessAlert, setBigQuerySuccessAlert] = useState(false);

  const location = useLocation();
  const [data, setData] = useState([]);
  const [columnNames, setcolumnNames] = useState([]);
  const [datasets, setDatasets] = useState([]);
  const [selectedDataset, setSelectedDataset] = useState(null);

  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);

  const [files, setFiles] = useState([]);
  const [showFilePreview, setShowFilePreview] = useState(false);
  const [filePreview, setFilePreview] = useState(null);

  async function fetchUploadedFileContent(file_name) {
    if (file_name === "SARAH WILLIAMS.pdf") {
      setFilePreview(pdf1);
    } else if (file_name === "SOPHIA HARRIS – PHSP Agreement.pdf") {
      setFilePreview(pdf2);
    }

    // Demo: always show local PDF
    // setFilePreview(DummyPDF);
  }
  useEffect(() => {
    // Force loader ON at the start
    setLoading(true);

    const table_data =
      selectSelectedModulesIDRedux === 5
        ? generalizeTableClaimJSON(selectUploadFileModuleDataRedux)
        : selectUploadFileModuleDataRedux;

    const files_data = selectUploadFileModuleFileRedux?.length
      ? selectUploadFileModuleFileRedux
      : [
          { name: "SARAH WILLIAMS.pdf" },
          { name: "SOPHIA HARRIS - PHSP Agreement.pdf" },
        ];

    const timer = setTimeout(() => {
      setData(table_data);
      setFiles(files_data);

      if (table_data && table_data.length > 0) {
        setcolumnNames(Object.keys(table_data[0]));
      } else {
        setcolumnNames([]);
      }

      setLoading(false);
    }, 6000); // 6 seconds delay

    return () => clearTimeout(timer); // cleanup on unmount
  }, [location.state, selectUploadFileModuleDataRedux]);

  const handleDownloadFileClick = async () => {
    try {
      const response = await axios.post(`${api_url}/download`, data, {
        responseType: "blob", // important
      });

      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error(error);
    }
  };
  const handleBigQueryClick = async () => {
    setOpenModal(true);
    fetchList("", `${api_url}/bigquery/datasets`)
      .then((response) => {
        setDatasets(response.datasets);
        setModalLoading(false);
      })
      .catch((error) => {
        alert(error);
      });
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    setModalLoading(true);
    addFunction(
      "",
      {
        datasetId: selectedDataset,
        tableId: selectedTable,
        data: data,
      },
      `${api_url}/bigquery/write`
    )
      .then((response) => {
        setOpenModal(false);
        // alert("Data successfully loaded!");
        setBigQuerySuccessAlert(true);
        // schedule the state update to false after 5 seconds
        setTimeout(() => {
          setBigQuerySuccessAlert(false);
        }, 3500);
      })
      .catch((error) => {
        alert(error);
      });
  };

  const columns = React.useMemo(
    () =>
      columnNames.map((name) => ({
        Header: name,
        accessor: name,
      })),
    [columnNames]
  );

  const dataTable = React.useMemo(() => data, [data]);

  // ----------------------------

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
  } = tableInstance;
  initialState.pageSize = 11;
  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const brandColor = useColorModeValue("brand.500", "white");

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box>
          <Box>
            <SidebarContext.Provider>
              <Sidebar />
              <Box
                float="right"
                minHeight="100vh"
                height="100%"
                overflow="auto"
                position="relative"
                maxHeight="100%"
                w={{ base: "100%", xl: "calc( 100% - 290px )" }}
                maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
                transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                transitionDuration=".2s, .2s, .35s"
                transitionProperty="top, bottom, width"
                transitionTimingFunction="linear, linear, ease"
              >
                <Portal>
                  <Box>
                    <Navbar
                      onOpen={onOpen}
                      logoText={"Horizon UI Dashboard PRO"}
                      brandText={getActiveRoute(routes)}
                      secondary={getActiveNavbar(routes)}
                      message={getActiveNavbarText(routes)}
                      fixed={false}
                      handleDownloadFileClick={handleDownloadFileClick}
                      handleBigQueryClick={handleBigQueryClick}
                      // {...rest}
                    />
                  </Box>
                </Portal>
                <Box
                  mx="auto"
                  p={{ base: "20px", md: "30px" }}
                  pe="20px"
                  minH="100vh"
                  pt="50px"
                >
                  <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
                    <>
                      {loading ? (
                        <Loader />
                      ) : (
                        <>
                          <SimpleGrid
                            columns={{ base: 1, md: 2, lg: 3, "2xl": 5 }}
                            gap="20px"
                            mb="20px"
                          >
                            {files.map((file, i) => (
                              <MiniStatistics
                                key={i}
                                onClick={() => {
                                  fetchUploadedFileContent(file.name);

                                  setShowFilePreview(true);
                                }}
                                startContent={
                                  <IconBox
                                    w="56px"
                                    h="56px"
                                    bg={boxBg}
                                    icon={
                                      <Icon
                                        w="32px"
                                        h="32px"
                                        as={MdBarChart}
                                        color={brandColor}
                                      />
                                    }
                                  />
                                }
                                name={file.name}
                                // value="$350.4"
                              />
                            ))}
                          </SimpleGrid>
                          <Card
                            direction="column"
                            w="100%"
                            px="0px"
                            overflowX={{ sm: "scroll", lg: "hidden" }}
                            pb="0px"
                          >
                            <Flex
                              px="25px"
                              justify="space-between"
                              mb="20px"
                              align="center"
                            >
                              <Text
                                color={textColor}
                                fontSize="22px"
                                fontWeight="700"
                                lineHeight="100%"
                              >
                                Preview Data
                              </Text>
                              {[5].includes(selectSelectedModulesIDRedux) ? (
                                <Button
                                  onClick={() => {
                                    navigate("/claim", {
                                      state: { data: data, files: files },
                                    });
                                  }}
                                  w="120px"
                                  minW="140px"
                                  mt={{ base: "20px", "2xl": "auto" }}
                                  variant="brand"
                                  fontWeight="500"
                                  rounded="10px"
                                >
                                  Check Claims
                                </Button>
                              ) : (
                                <></>
                              )}
                            </Flex>

                            <ResizableTable
                              columns={columns}
                              data={dataTable}
                            />
                          </Card>
                        </>
                      )}
                    </>
                  </Box>
                </Box>
              </Box>
            </SidebarContext.Provider>
          </Box>
        </Box>
      )}
      {filePreview === null ? (
        <></>
      ) : (
        <ModalAllPages
          filePreview={filePreview}
          setShowFilePreview={setShowFilePreview}
          showFilePreview={showFilePreview}
        />
      )}

      <BigQueryModal
        openModal={openModal}
        modalLoading={modalLoading}
        handleFormSubmit={handleFormSubmit}
        setOpenModal={setOpenModal}
        selectedDataset={selectedDataset}
        datasets={datasets}
        setSelectedDataset={setSelectedDataset}
        setTableLoading={setTableLoading}
        setTables={setTables}
        selectedTable={selectedTable}
        tableLoading={tableLoading}
        tables={tables}
        setSelectedTable={setSelectedTable}
      />
    </>
  );
}
